import { IAction } from '../identity-interfaces';
import { identityActionTypes } from '../identity-action-types';
import { BASE_URL } from '../../../../config/environmentConfig';
import { GET, POST } from '../../store-helper';

export const fetchAccountManagerList = async (dispatch: React.Dispatch<IAction>): Promise<void> => {
  dispatch({ type: identityActionTypes.SET_ACCOUNT_MANAGER_LIST_LOADING, payload: true });
  try {

    const data = await GET({ pathname: `${BASE_URL.IDENTITY}/users/select-list` });

    const accountManagerList = data
      ? data
        .filter((item: any) => item.name?.length > 1)
        .map((item: any) => ({
          label: item.name,
          value: item.id
        }))
      : [];
    console.log('accountManagerList', accountManagerList);
    dispatch({ type: identityActionTypes.FETCH_ACCOUNT_MANAGER_LIST, payload: accountManagerList });
  } catch (e) {
    dispatch({ type: identityActionTypes.FETCH_ACCOUNT_MANAGER_LIST, payload: [] });
    console.log('fetchAccountManagerList', e);
  }
};

interface IResendInvitation {
  dispatch: React.Dispatch<IAction>;
  email: string;
  onSuccess: (email: string) => void;
  onError: () => void;
}

export const resendInvitationToApplicant = async ({ dispatch, email, onSuccess, onError }: IResendInvitation): Promise<void> => {
  try {
    dispatch({ type: identityActionTypes.SET_RESEND_INVITATION_LOADING, payload: true });
    await POST({ pathname: `${BASE_URL.IDENTITY}/identity/resend-invitation`, body: { email }});
    onSuccess(email);
    dispatch({ type: identityActionTypes.SET_RESEND_INVITATION_LOADING, payload: false });
  } catch (e) {
    dispatch({ type: identityActionTypes.SET_RESEND_INVITATION_LOADING, payload: false });
    onError();
    console.log('resendInvitationToApplicant error', e);
  }
};
